import CustomFieldCell from './CustomFieldCell';
import { MappedField } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  fields: MappedField[];
}

const CustomFieldRow = ({ fields }: Props) => {
  return (
    <div className={classes.customFieldRow}>
      {fields.map(field => (
        <CustomFieldCell key={field?.id} field={field} />
      ))}
    </div>
  );
};

export default CustomFieldRow;
